import { useParams, usePathname } from 'next/navigation';

import { isThemePage, parseThemeSlug } from '../helpers';

export function useThemeSearchParam() {
  const pathName = usePathname();
  const { slug } = useParams<{ slug?: string }>();
  const { keywords } = parseThemeSlug(slug ?? '');

  return { searchInput: isThemePage(pathName) ? keywords : null };
}
